import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntil } from 'rxjs';
import { BaseResizableComponent } from '@src/app/modules/base';
import { SessionService } from '@src/app/modules/auth';
import { StorageKeys } from '@src/constants/storage';
import { PreviousRouteService } from '@src/core/services';
import { ListModeType } from '@src/app/modules/list-mode-switcher';
import { CitySwitcherItemType } from '@src/app/modules/search-cities/city-switcher/types';

import { LoyaltyProgramReadService, LpNewProductsStoreService } from '../services';
import { LoyaltyProgramListProduct } from '../models';

@Component({
  selector: 'lp-collection-new',
  templateUrl: './lp-collection-new.component.html',
  styleUrls: ['./lp-collection-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpCollectionNewComponent extends BaseResizableComponent {
  private readonly loyaltyProgramReadService = inject(LoyaltyProgramReadService);
  private readonly session = inject(SessionService);
  private readonly previousRouteService = inject(PreviousRouteService);
  private readonly lpNewProductsStore = inject(LpNewProductsStoreService);

  products?: LoyaltyProgramListProduct[];

  productListMode: ListModeType = 'grid';
  readonly listModeStorageKey = StorageKeys.LpProductListMode;

  get currentCity() {
    return this.session.currentCity;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.refresh(this.currentCity);

    this.lpNewProductsStore.data$.pipe(takeUntil(this.destroyed$$)).subscribe(() => {
      this.products = this.currentCity?.cityId
        ? this.lpNewProductsStore.getData(this.currentCity.cityId.toString())
        : [];

      this.cdr.markForCheck();
    });
  }

  onClickBackButton() {
    this.previousRouteService.back('/loyalty');
  }

  refresh(city: CitySwitcherItemType) {
    this.loyaltyProgramReadService.getNewProducts(city?.cityId);
  }
}
